import React, { useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogTrigger } from "@/components/ui/dialog";
import { Loader2, Plus, Trash2, Tags } from "lucide-react";
import { toast } from "sonner";
import { FUNCOES } from "@/components/ResponsaveisConfig";

export const labelFuncao = (funcao, custom = []) => (FUNCOES.find(([k]) => k === funcao) || [])[1] || custom.find((c) => c.id === funcao)?.label || funcao;

/** Cargos personalizados (identificação nos textos) da empresa. Não altera função de acesso nem permissões. */
export function FuncoesPersonalizadasDialog({ itens, onSaved }) {
  const [open, setOpen] = useState(false);
  const [lista, setLista] = useState(itens);
  const [novo, setNovo] = useState("");
  const [saving, setSaving] = useState(false);
  const add = () => { const l = novo.trim(); if (!l) return; setLista((p) => [...p, { id: "", label: l }]); setNovo(""); };
  const save = async () => {
    setSaving(true);
    try { const { data } = await api.put("/funcoes-personalizadas", { itens: lista }); toast.success("Funções salvas"); onSaved(data.itens); setOpen(false); }
    catch (e) { toast.error(e.response?.data?.detail || "Erro ao salvar"); }
    finally { setSaving(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(v) => { setOpen(v); if (v) setLista(itens); }}>
      <DialogTrigger asChild><Button variant="outline" className="gap-2" data-testid="funcoes-btn"><Tags className="w-4 h-4" /> Funções</Button></DialogTrigger>
      <DialogContent className="max-w-md w-[calc(100vw-2rem)]" data-testid="funcoes-dialog">
        <DialogHeader><DialogTitle>Funções personalizadas (identificação nos textos)</DialogTitle></DialogHeader>
        <p className="text-xs text-slate-500">Cargos exibidos nos textos e documentos, além das opções padrão ({FUNCOES.filter(([k]) => k !== "agente_campo").map(([, l]) => l).join(", ")}). Não altera a função de acesso nem as permissões.</p>
        <div className="space-y-2">
          {lista.map((it, i) => (
            <div key={it.id || `n${i}`} className="flex gap-2">
              <Input value={it.label} onChange={(e) => setLista((p) => p.map((x, j) => (j === i ? { ...x, label: e.target.value } : x)))} data-testid={`funcao-item-${i}`} />
              <Button variant="ghost" size="icon" className="text-red-600 shrink-0" onClick={() => setLista((p) => p.filter((_, j) => j !== i))} data-testid={`funcao-remover-${i}`}><Trash2 className="w-4 h-4" /></Button>
            </div>
          ))}
          {!lista.length && <p className="text-xs text-slate-400">Nenhuma função personalizada.</p>}
          <div className="flex gap-2">
            <Input value={novo} onChange={(e) => setNovo(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()} placeholder="Ex.: Gerente de Carteira" data-testid="funcao-nova" />
            <Button variant="outline" onClick={add} className="shrink-0 gap-1" data-testid="funcao-add"><Plus className="w-4 h-4" /> Adicionar</Button>
          </div>
        </div>
        <DialogFooter><Button onClick={save} disabled={saving} className="bg-onyx text-white" data-testid="funcoes-salvar">{saving ? <Loader2 className="w-4 h-4 animate-spin" /> : "Salvar"}</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
